import axios from "axios";
import { BASE_API_URL } from "../consts";

export interface FloorPlanTemplate {
  _id: string;
  clientId: string;
  name: string;
  tableCount: number;
  layout: { number: number; x: number; y: number }[];
  createdAt: string;
}

export const getFloorPlanTemplates = (clientId: string) =>
  axios.get<FloorPlanTemplate[]>(`${BASE_API_URL}/${clientId}/floor-plan-templates`);

export const createFloorPlanTemplate = (
  clientId: string,
  data: { name: string; tableCount: number; layout: { number: number; x: number; y: number }[] }
) => axios.post<FloorPlanTemplate>(`${BASE_API_URL}/${clientId}/floor-plan-templates`, data);

export const deleteFloorPlanTemplate = (id: string) =>
  axios.delete(`${BASE_API_URL}/floor-plan-templates/${id}`);
